import { render, staticRenderFns } from "./ProjectDashboard.vue?vue&type=template&id=2d467472&scoped=true"
import script from "./ProjectDashboard.vue?vue&type=script&lang=ts"
export * from "./ProjectDashboard.vue?vue&type=script&lang=ts"
import style0 from "./ProjectDashboard.vue?vue&type=style&index=0&id=2d467472&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d467472",
  null
  
)

export default component.exports